module.exports = __webpack_public_path__ + "img/tuition-title.6f4013bc.svg";